module.exports = __webpack_public_path__ + "static/assets/b68fc6a28679006b6f3c467247c1a6e5.png";